// The collection (ADR 0017): what a player added from the store. The server keeps it; this module names the official
// entries every new account starts with, and tells the client and the server alike which ids are published creations.
import type { CreationKind } from '@gruvetto/contracts';

/**
 * Official entries a new account starts with: enough to race, train and dress the default rider. Everything else
 * official (other modes, tracks, workouts, plans, moods, jerseys, games) waits in the store, free, level permitting.
 * The database migration that backfills existing accounts lists the same ids (apps/api/drizzle, 0014).
 */
export const STARTER_COLLECTION: readonly { id: string; kind: CreationKind }[] = [
  { id: 'race', kind: 'mode' }, { id: 'tt', kind: 'mode' }, { id: 'free', kind: 'mode' },
  { id: 'collines', kind: 'track' }, { id: 'mur', kind: 'track' },
  { id: 'golden', kind: 'theme' },
  { id: 'decouverte', kind: 'workout' }, { id: 'endurance60', kind: 'workout' }, { id: 'ss2x20', kind: 'workout' }, { id: 'ftp20', kind: 'workout' }, { id: 'recup30', kind: 'workout' },
  { id: 'debut4', kind: 'plan' },
  { id: 'jersey-uni', kind: 'cosmetic' }, { id: 'frame-couleur', kind: 'cosmetic' }, { id: 'helmet-couleur', kind: 'cosmetic' }, { id: 'wheels-carbone', kind: 'cosmetic' },
  { id: 'dynamo', kind: 'game' },
];
/** Ids of the official games (packages/creations/src/games): listed here so the API, which never bundles the games' code, can offer them. */
export const OFFICIAL_GAME_IDS: readonly string[] = ['dynamo', 'zeppelin', 'neon', 'cadence', 'horde', 'pong'];
export const isStarterItem = (id: string) => STARTER_COLLECTION.some(s => s.id === id);
/** Ids of published creations start with this prefix; every other store id names an official entry. */
export const isPublishedId = (id: string) => id.startsWith('cr_');
